export enum ProfileConstants {
    ADMINISTRATOR = 1,
    DOCTOR,
    RECEPTIONIST,
    OWNER
}
